<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.8261 24.3478C27.8261 29.3424 23.7772 33.3913 18.7826 33.3913C13.788 33.3913 9.73914 29.3424 9.73914 24.3478C9.73914 19.3532 13.788 15.3043 18.7826 15.3043C23.7772 15.3043 27.8261 19.3532 27.8261 24.3478ZM23.6522 24.3478C23.6522 27.0372 21.472 29.2174 18.7826 29.2174C16.0932 29.2174 13.913 27.0372 13.913 24.3478C13.913 21.6584 16.0932 19.4783 18.7826 19.4783C21.472 19.4783 23.6522 21.6584 23.6522 24.3478Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M59.1304 58.4348C61.8198 58.4348 64 56.2546 64 53.5652V10.4348C64 7.74539 61.8198 5.56522 59.1304 5.56522H4.86957C2.18017 5.56522 0 7.74539 0 10.4348V53.5652C0 56.2546 2.18017 58.4348 4.86957 58.4348H59.1304ZM4.86957 9.73913C4.48537 9.73913 4.17391 10.0506 4.17391 10.4348V53.5652C4.17391 53.9495 4.48537 54.2609 4.86957 54.2609H13.7128L37.5641 29.1542C39.4502 27.1689 42.6017 27.1285 44.5379 29.0648L59.8261 44.3528V10.4348C59.8261 10.0506 59.5147 9.73913 59.1304 9.73913H4.86957ZM59.8261 53.5652V50.2559L41.5864 32.0161C41.3098 31.7396 40.8595 31.7453 40.5902 32.0289L19.4699 54.2609H59.1304C59.5147 54.2609 59.8261 53.9495 59.8261 53.5652Z"
    />
  </g>
</template>
